import type { ReactNode } from 'react'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { CommandItem } from '@/components/ui/command'
import { getInitials } from '@/lib/initials.util'
import { cn } from '@/lib/utils'

export interface AddParticipantMemberItemProps {
  id: string
  name: string
  avatarUrl?: string
  isDisabled?: boolean
  onSelect: (userId: string) => void
  className?: string
}

/**
 * A selectable member item for the add participant dialog.
 * Displays avatar, name, and handles selection.
 */
export const AddParticipantMemberItem: React.FC<AddParticipantMemberItemProps> = ({
  id,
  name,
  avatarUrl,
  isDisabled = false,
  onSelect,
  className,
}): ReactNode => (
  <CommandItem
    value={`${name}-${id}`}
    disabled={isDisabled}
    onSelect={() => onSelect(id)}
    className={cn('add-participant-member-item gap-3 px-3 py-2', className)}
  >
    <Avatar className="size-8">
      <AvatarImage src={avatarUrl} alt={name} />
      <AvatarFallback className="text-xs">{getInitials(name)}</AvatarFallback>
    </Avatar>
    <span className="truncate text-sm">{name}</span>
  </CommandItem>
)

AddParticipantMemberItem.displayName = 'AddParticipantMemberItem'
